import { FLAGS } from '@iheartjane/feature-flags';
import {
  Box,
  Button,
  DismissIcon,
  Flex,
  Link,
  PremiumBagIcon,
  Typography,
} from '@iheartjane/reefer';

import { useFullDestination } from '@jane/bloom/hooks/navigation/useFullDestination';
import { useRootLoaderData } from '@jane/bloom/hooks/useRootLoaderData';
import { useAuthModal } from '@jane/bloom/providers/authModalProvider';
import { getSignInPromptDefaults } from '@jane/bloom/resources/signInPromptTheme';

import styles from './mobileLoginCallout.module.css';

interface MobileLoginCalloutProps {
  onDismiss: () => void;
}

export const MobileLoginCallout = ({ onDismiss }: MobileLoginCalloutProps) => {
  const { featureFlags, pinnedStore, theme } = useRootLoaderData();
  const generatePath = useFullDestination();
  const bankLinkingEnabled = featureFlags[FLAGS.obGoldBankLinking];
  const { openAuthModal } = useAuthModal();
  const lp = featureFlags[FLAGS.c1CustomizeLoginPrompt]
    ? theme.bloom?.login_prompt
    : undefined;
  const defaults = getSignInPromptDefaults(
    pinnedStore?.crm_integration === 'alpineiq'
  );

  // Custom button colors are deliberately NOT read here — they are
  // desktop-only per the feature spec. Use || (not ??) so empty strings fall
  // through to defaults.
  const header = lp?.mobile_header || lp?.header || defaults.mobile_header;
  const body = lp?.mobile_copy || defaults.mobile_copy;
  const ctaLabel = lp?.cta_label || defaults.cta_label;

  return (
    <Box
      className={styles['container']}
      p={16}
      m={8}
      background="grays-white"
      borderRadius="lg"
      border="grays-light"
    >
      <Flex alignItems="center" gap={16} className={styles['promptIcon']}>
        <PremiumBagIcon size="xl" color="inherit" />
        <Flex flexDirection="column">
          <Typography variant="body-bold">{header}</Typography>
          <Typography>{body}</Typography>
          <Link
            {...(bankLinkingEnabled
              ? { onClick: () => openAuthModal() }
              : { to: generatePath('/login') })}
          >
            {ctaLabel}
          </Link>
        </Flex>

        <Button.Icon
          icon={<DismissIcon altText="dismiss login prompt" />}
          onClick={onDismiss}
          className={styles['dismissButton']}
        />
      </Flex>
    </Box>
  );
};
